import { render, staticRenderFns } from "./m-organization-details.vue?vue&type=template&id=3341e47e&scoped=true&lang=pug"
import script from "./m-organization-details.vue?vue&type=script&lang=js"
export * from "./m-organization-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3341e47e",
  null
  
)

export default component.exports